import {BASE_URL} from 'appConstants';
import {get, post} from 'sdk';

export const fetchUsers = ({extraGetParams}) => {
  const url = `${BASE_URL}/v1/users/`;

  return get(url, extraGetParams);
};

export const promoteToMember = ({userId}) => {
  const url = `${BASE_URL}/v1/users/promote-to-member/`;

  return post(url, {user: userId});
};

export const fetchUser = ({userId}) => {
  const url = `${BASE_URL}/v1/users/${userId}/`;

  return get(url);
};

export const createMember = ({email, fullName}) => {
  const url = `${BASE_URL}/v1/users/create-member/`;
  const payload = {email, fullName};

  return post(url, payload);
};

export const createUser = ({email, fullName}) => {
  const url = `${BASE_URL}/v1/users/create-user/`;
  const payload = {email, fullName};

  return post(url, payload);
};

export const updateUser = ({
  fullName,
  email,
  knownAs,
  phone,
  age,
  gender,
  birthday,
  nationality,
  newJoiner,
  bio,
  userId
}) => {
  const url = `${BASE_URL}/v1/users/update-user/${userId}/`;
  const payload = {
    fullName,
    email,
    knownAs,
    phone,
    age,
    gender,
    birthday,
    nationality,
    newJoiner,
    bio
  };

  return post(url, payload);
};

export const signUserInternalAvatar = ({filename, fileType, userId}) => {
  const url = `${BASE_URL}/v1/users/${userId}/internal-avatar-sign/`;
  const payload = {filename, fileType};

  return post(url, payload);
};

export const verifyUserInternalAvatarUpload = ({identifier, userId}) => {
  let url = `${BASE_URL}/v1/users/${userId}/internal-avatar-verify-upload/`;
  const payload = {
    identifier
  };

  return post(url, payload);
};

export const demoteMember = ({memberId}) => {
  const url = `${BASE_URL}/v1/users/members/demote/`;
  const payload = {
    member: memberId
  };

  return post(url, payload);
};

export const fetchMembersForDashboard = ({locationRef, extraGetParams}) => {
  const url = `${BASE_URL}/v1/living/tenant/${locationRef}/list/`;

  return get(url, extraGetParams);
};

export const fetchMemberForDashboard = ({locationRef, memberId}) => {
  const url = `${BASE_URL}/v1/living/tenant/${locationRef}/detail/${memberId}/`;

  return get(url);
};

export const fetchMemberBookingSets = ({locationRef, memberId}) => {
  const url = `${BASE_URL}/v1/living/booking-sets/${locationRef}/`;
  const params = {
    tenant: memberId
  };
  return get(url, params);
};

export const exportMembersCsv = ({locationRef, filters}) => {
  const url = `${BASE_URL}/v1/living/tenant/${locationRef}/export/`;
  const params = {...filters};

  return get(url, params);
};

export const exportSingleMemberCsv = ({locationRef, tenantId}) => {
  const url = `${BASE_URL}/v1/living/tenant/${locationRef}/export-single/`;
  const payload = {
    tenant: tenantId
  };

  return post(url, payload);
};
